export const removeDuplicatesById = (array) => {
    const uniqueParticipants = {};
    array.forEach(participant => {
        uniqueParticipants[participant.id] = participant;
    });
    return Object.values(uniqueParticipants);
};
